import { render, staticRenderFns } from "./customBoard.vue?vue&type=template&id=72e34ac3&scoped=true&"
import script from "./customBoard.vue?vue&type=script&lang=js&"
export * from "./customBoard.vue?vue&type=script&lang=js&"
import style0 from "./customBoard.vue?vue&type=style&index=0&id=72e34ac3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e34ac3",
  null
  
)

export default component.exports